// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__WzX4O","small":"styles_small__4NRFh"};